import { createContext, useContext, useState } from 'react';
import { users } from '../data/settings';

// ─── Context ──────────────────────────────────────────────────────────────────
const MockAuthContext = createContext(null);

const STORAGE_KEY     = 'mockUserId';
const LOGGED_IN_KEY   = 'mockLoggedIn';
const SHARED_PASSWORD = 'Coverit2026!';

function resolveUser(id) {
  return users.find((u) => u.id === id) ?? users[0];
}

// ─── Provider ─────────────────────────────────────────────────────────────────
export function MockAuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return resolveUser(stored);
  });

  const [isLoggedIn, setIsLoggedIn] = useState(
    () => localStorage.getItem(LOGGED_IN_KEY) === 'true',
  );

  // ── Switch dev user (DevUserSwitcher only — does not affect login state) ──
  const setMockUser = (userId) => {
    localStorage.setItem(STORAGE_KEY, userId);
    setCurrentUser(resolveUser(userId));
  };

  // ── Login — matches email + shared password, rejects inactive users ────────
  // Returns the matched user object on success, null on failure.
  const login = (email, password) => {
    if (password !== SHARED_PASSWORD) return null;
    const matched = users.find(
      (u) =>
        u.email.toLowerCase() === email.trim().toLowerCase() &&
        u.active !== false,
    );
    if (!matched) return null;
    localStorage.setItem(STORAGE_KEY, matched.id);
    localStorage.setItem(LOGGED_IN_KEY, 'true');
    setCurrentUser(matched);
    setIsLoggedIn(true);
    return matched;
  };

  // ── Logout ─────────────────────────────────────────────────────────────────
  const logout = () => {
    localStorage.removeItem(LOGGED_IN_KEY);
    localStorage.removeItem(STORAGE_KEY);
    setIsLoggedIn(false);
  };

  const value = {
    currentUser,
    setMockUser,
    isLoggedIn,
    login,
    logout,
    isCustomer: currentUser.role === 'Customer',
    isInternal: currentUser.role !== 'Customer',
  };

  return (
    <MockAuthContext.Provider value={value}>
      {children}
    </MockAuthContext.Provider>
  );
}

// ─── Hook ─────────────────────────────────────────────────────────────────────
export function useAuth() {
  const ctx = useContext(MockAuthContext);
  if (!ctx) throw new Error('useAuth must be used within MockAuthProvider');
  return ctx;
}
